<template>
  <v-dialog v-model="show" persistent width="90%">
    <v-card :loading="loading">
      <v-card-title>Transaction error for {{name}}</v-card-title>
      <v-divider/>
      <v-card-text>
        <div class="error--text pa-2 text-body-1">{{error.message}}</div>

        <v-simple-table fixed-header height="300">
          <thead>
            <tr>
              <th width="15%">Date</th>
              <th width="30%">Transaction</th>
              <th width="25%">Alcohol</th>
              <th width="15%" class="text-right">{{info.quantity ? 'Volume' : '$'}}</th>
              <th width="15%" class="text-right">Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(line,index) in lines" :class="{'font-weight-bold':index===1, 'error--text':index>0 && (line.balance<0 || line.alcoholType!==info.alcoholType)}">
              <td>{{line.date | formatDateTime}}</td>
              <td>{{line.description}}</td>
              <td>{{line.alcoholName}}</td>
              <td class="text-right">
                <template v-if="info.quantity">
                  {{line.amount | number(3)}} <template v-if="line.amount!==undefined">{{line.alcoholType==='Spirit'?'LAA':'litres'}}</template>
                </template>
                <template v-else>{{line.amount | number(2)}}</template>
              </td>
              <td class="text-right">
                <template v-if="info.quantity">
                  {{line.balance | number(3)}} {{line.alcoholType==='Spirit'?'LAA':'litres'}}
                </template>
                <template v-else>{{line.balance | number(2)}}</template>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="show=false;$emit('done')">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {add,format} from 'date-fns';

export default {
  name: 'ExciseVesselTransactionError',
  data() {
    return {
      show: true,
      name: '',
      lines: []
    }
  },
  computed: {
    error() {
      return this.$store.state.error;
    },
    info() {
      return this.error.info;
    }
  },
  async created() {
    this.loading = true;
    const results = await this.$apiCall(`query ExciseVesselTransactionError($id:ID!,$asof:DateTime!) {
                                              exciseVessel(id:$id) {
                                                name
                                                contents(date:$asof) {volume,value,alcoholName,alcoholType}

                                                transactions2(first:100, sortKey:"date", reverse:false,
                                                              filters:[{field:"from", comparator:ge, value:"${this.info.transactionDate.substring(0,10)}"},
                                                                       {field:"to", comparator:le, value:"${this.info.errorDate.substring(0,10)}"}]) {
                                                  edges {
                                                    node {
                                                      refId,date,description,volume,value,alcoholName,alcoholType
                                                    }
                                                  }
                                                }
                                              }
                                            }`,
                                        {id:this.info.vesselId,
                                          asof: format(add(new Date(this.info.transactionDate), {seconds:-1}), 'yyyy-MM-dd HH:mm:ss')});
    if (!results.error) {
      const vessel = results.data.exciseVessel;
      this.name = vessel.name;
      let balance = vessel.contents[this.info.quantity ? 'volume' : 'value'];
      this.lines.push({description:'Balance forward',balance,alcoholName:vessel.contents.alcoholName,alcoholType:vessel.contents.alcoholType});
      balance += this.info.amount;
      this.lines.push({date:this.info.transactionDate,description:'PROPOSED TRANSACTION',amount:this.info.amount,balance,alcoholType:this.info.alcoholType,alcoholName:this.info.alcoholName});
      for (const edge of vessel.transactions2.edges) {
        const transaction = edge.node;
        if (transaction.refId === this.info.transactionId || transaction.date < this.info.transactionDate)
          continue;
        const amount = this.info.quantity ? transaction.volume : transaction.value;
        balance += amount;
        this.lines.push({...transaction,amount,balance});
      }

    }
    this.loading = false;
  }
}
</script>